import axiosPost from "./axiosPost";

export const RNHComponenteSecundarioGet = async (credentials, data) => {
    const body = {
        service: "RNHComponenteSecundarioGet",
        params: {
            rnhComponenteSecundarioId: data?.id || null,
        },
    };

    const result = await axiosPost(body, credentials);
    if(result?.status?.code === 0) {
        return [result.status]
    } else {
        return result.result;
    }
};
